/* Communities RV Hero */
import 'slick-carousel';
import 'select2';
import Datepicker from 'vanillajs-datepicker/Datepicker';
import * as bootstrap from 'bootstrap';

export function communities_rv_hero() {

	( ( $ ) => {

		const init = () => {

			if ( $( '.block--communities-rv-hero' ).length <= 0 ) {
				return;
			}

			$( '.block--communities-rv-hero--gallery' ).each( ( i, e ) => {
				const slider = $( e );

				slider.slick( {
					arrows: false,
					autoplay: true,
					autoplaySpeed: 3000,
					dots: false,
					fade: true,
					infinite: true,
					pauseOnFocus: false,
					pauseOnHover: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					swipe: false,
					rows: 0
				} );
			} );

			// Select2 for destinations
			
			const selector = $( '.block--communities-rv-hero' ).find( '#home-sales-community' );

			selector.select2( {
				allowClear: true,
				width: '100%',
				dropdownParent: $( '#home-sales-community' ).parent(),
				ajax: {
					url: '/wp-json/pri-rest-extender/v1/search',
					dataType: 'json',
					data: ( params ) => {
						params.type = 'rv';
						return params;
					}
				}
			} );

			// Datepicker stuff

			const datefield_arrival = $( '.block--communities-rv-hero' ).find( '#rv-arrival-date' );
			const datefield_departure = $( '.block--communities-rv-hero' ).find( '#rv-departure-date' );

			if ( datefield_arrival.length == 0 || datefield_departure == 0 ) {
				return;
			}

			const datepicker_arrival = new Datepicker( datefield_arrival[0], {
				buttonClass: 'btn',
			} );

			const datepicker_departure = new Datepicker( datefield_departure[0], {
				buttonClass: 'btn',
			} );

			const set_datepickers = ( response, status ) => {

				if ( 'success' != status ) {
					show_alert( 'There was an error during the connection to the booking service. Please, try again.', '#rv-accommodation-type' );
					return false;
				}

				// Let's setup the hidden stuff that rely on the response
				if ( response.holiday_type_id ) {
					$( '.block--communities-rv-hero' ).find( '#rv-holiday-type' ).val( response.holiday_type_id );
				}

				// Config the arrival
				let datepicker_config = {
					minDate: response.usa_min_date,
					maxDate: response.usa_max_date
				};

				if ( response.usa_disabled_dates && response.usa_disabled_dates.length > 0 ) {
					datepicker_config.datesDisabled = response.usa_disabled_dates;
				}

				// Enable it
				datefield_arrival.prop( 'disabled', false );

				datepicker_arrival.setOptions( datepicker_config );

				// Now the departure, when we change the arrival, of course
				$( datefield_arrival[0] )
					.off( 'changeDate.booking.cove' )
					.on( 'changeDate.booking.cove', ( ev ) => {
						const currentDate = new Date( $( ev.currentTarget ).val() );

						for ( const result of response.results ) {
							const startDate = new Date( result.start_date );
							const endDate = new Date( result.end_date );
		
							if ( currentDate >= startDate && currentDate <= endDate ) {
								let min_date = new Date();
								let max_date = new Date();

								min_date.setTime( currentDate.getTime() );
								max_date.setTime( currentDate.getTime() );

								min_date.setDate( currentDate.getDate() + parseInt( result.min_nights ) );
								max_date.setDate( currentDate.getDate() + parseInt( result.max_nights ) );

								datepicker_departure.setOptions( {
									minDate: min_date,
									maxDate: max_date
								} );
							}
						}
					} );
			}

			const set_days_value = ( ev ) => {
				let arrival				= new Date( datefield_arrival.val() );
				let departure			= new Date( datefield_departure.val() );
				const $rvDays			= $( '#rv-days', '.block--communities-rv-hero' );
				const $rvArriveDate		= $( '#rv-arrive-date', '.block--communities-rv-hero' );
				const $rvNumberNights	= $( '#rv-number-nights', '.block--communities-rv-hero' );

				$rvDays.val( '' );
				$rvArriveDate.val( '' );
				$rvNumberNights.val( '' );

				if ( ! isNaN( arrival.getTime() ) && ! isNaN( departure.getTime() ) ) {
					let difference = departure.getTime() - arrival.getTime();
					let days = Math.round( difference / ( 1000 * 3600 * 24 ) );
					let day_text = ( days == 1 ) ? 'night' : 'nights';
					$rvDays.val( `${days} ${day_text}` ).prop( 'disabled', false );
					$rvNumberNights.val( days );

					// Set the hidden fields to YYYY-MM-DD
					$rvArriveDate.val( arrival.toISOString().substring( 0, 10 ) );
				}
			}

			$( datefield_arrival[0] ).on( 'changeDate', set_days_value );
			$( datefield_departure[0] ).on( 'changeDate', set_days_value );

			// Enabling the form elements depending on conditionals
			$( '.block--communities-rv-hero' ).find( 'form select, form input' ).on( 'change changeDate', ( ev ) => {

				const form = $( ev.currentTarget ).parentsUntil( 'form' ).parent();

				// If the accommodation type changes, then reset the whole inputs
				if ( $( ev.currentTarget ).is( '#rv-accommodation-type' ) ) {
					form
						.find( 'input:not([type="hidden"])' )
						.prop( 'disabled', true )
						.val( '' );
				}

				if ( $( ev.currentTarget ).is( '#rv-arrival-date' ) ) {
					datefield_departure.val( '' );
				}

				// Workaround for the calendar fields
				datepicker_arrival.update( {
					forceRefresh: true
				} );

				datepicker_departure.update( {
					forceRefresh: true
				} );

				if ( $( ev.currentTarget ).val() != '' ) {

					// This was a switch, but since we only have one element to alter
					// then it became an if statement
					if ( 'rv-arrival-date' == $( ev.currentTarget ).prop( 'id' ) ) {
						form
							.find( '#rv-departure-date' )
							.prop( 'disabled', false );
					}

					// Do the search here
					$.ajax( {
						url: '/wp-json/pri-rest-extender/v1/booking/search',
						method: 'GET',
						data: {
							'rv_ipebble_park_id': form.find( '#rv-ipebble-park-id' ).val(),
							'rv_accommodation_type': form.find( '#rv-accommodation-type' ).val(),
						},
						success: set_datepickers
					} );
				}
			} );

			const show_alert = ( message, show_under_element ) => {

				const form = $( '.block--communities-rv-hero' ).find( 'form' );

				form.find( '.form-control' ).each( ( ind, ele ) => {
					const prev_pop = bootstrap.Popover.getInstance( ele );

					if ( null != prev_pop ) {
						prev_pop.dispose();
					}
				} );

				const pop = new bootstrap.Popover( form.find( show_under_element ).eq(0), {
					placement: 'bottom',
					content: message
				} );

				$( show_under_element ).on( 'focus', ( ev ) => {
					const prev_pop = bootstrap.Popover.getInstance( ev.currentTarget );

					if ( null != prev_pop ) {
						prev_pop.dispose();
					}
				} );

				pop.show();
			}


			// Sending the form
			$( '.block--communities-rv-hero' ).find( 'form' ).on( 'submit', ( ev ) => {

				const form = $( ev.currentTarget );
				
				if ( form.find( '#rv-accommodation-type' ).val() == form.find( '#rv-accommodation-type option:first' ).text() ) {
					show_alert( 'You must select an accommodation type', '#rv-accommodation-type' );
					return false;
				}

				if ( form.find( '#rv-arrival-date' ).val() == '' ) {
					show_alert( 'You must select an arrival date', '#rv-arrival-date' );
					return false;
				}

				if ( form.find( '#rv-departure-date' ).val() == '' ) {
					show_alert( 'You must select a departure date', '#rv-departure-date' );
					return false;
				}
			} );

		}

		init();

	} )( window.jQuery );
}